import axios from "axios";

const API = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,
});

API.interceptors.response.use(
    response => response,
    async error => {
        if (error.response?.status === 401 && !error.config._retry && !error.config.url.includes("/auth/")) {
            error.config._retry = true;
            try {
                await API.post("/auth/refresh");
                return API(error.config);
            } catch {
                window.location.href = "/login";
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

export function formatError(error) {
    const detail = error.response?.data?.detail;
    if (!detail) return error.message || "A apărut o eroare";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map(e => e.msg || JSON.stringify(e)).join(", ");
    return String(detail);
}

export default API;
